import { useEffect } from "react";

const EventbriteCheckout = ({ eventId }) => {
  useEffect(() => {
    // Load Eventbrite widget script only once
    if (!document.getElementById("eventbrite-widget-script")) {
      const script = document.createElement("script");
      script.id = "eventbrite-widget-script";
      script.src = "https://www.eventbrite.com/static/widgets/eb_widgets.js";
      script.async = true;

      script.onload = () => {
        createCheckoutWidget();
      };

      document.body.appendChild(script);
    } else {
      createCheckoutWidget();
    }

    function createCheckoutWidget() {
      if (window.EBWidgets) {
        window.EBWidgets.createWidget({
          widgetType: "checkout",
          eventId: eventId,
          modal: true,
          modalTriggerElementId: `buy-ticket-button-${eventId}`,
          onOrderComplete: () => {
            console.log("Order completed!");
          },
        });
      }
    }
  }, [eventId]);

  return (
    <button
      id={`buy-ticket-button-${eventId}`}
      className="theme-button text-white px-4 py-2 rounded hover:opacity-90"
    >
      Reserve Your Spot
    </button>
  );
};

export default EventbriteCheckout;